import { render, staticRenderFns } from "./PicModel.vue?vue&type=template&id=62e915c0&scoped=true"
import script from "./PicModel.vue?vue&type=script&lang=js"
export * from "./PicModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e915c0",
  null
  
)

export default component.exports